module.exports = __webpack_public_path__ + "img/p25.8678a43b.png";